import React, { useState, useMemo } from 'react';
import css from './ListingPage.module.css';
import { Icons } from '../../components';
import { FormattedMessage } from 'react-intl';
import { useConfiguration } from '../../context/configurationContext';
import { FieldConfigKey } from '../../util/enums';
import { getLabelsFromOptions } from '../../util/genericHelpers';

const SpecificationsSection = ({ publicData }) => {
  const config = useConfiguration();
  const listingFields = config?.listing?.listingFields || [];
  const [open, setOpen] = useState(false);

  // Configuration for specifications mapping
  const specificationsConfig = useMemo(
    () => [
      {
        fieldKey: FieldConfigKey.BRAND_NAME,
        dataKey: 'brandname',
        labelId: 'ListingPage.brand',
        isArray: true,
      },
      {
        fieldKey: FieldConfigKey.SIZE,
        dataKey: 'size',
        labelId: 'ListingPage.size',
        isArray: true,
      },
      {
        fieldKey: FieldConfigKey.SOLE_TYPE,
        dataKey: 'soletype',
        labelId: 'ListingPage.soleType',
        isArray: true,
      },
      {
        fieldKey: FieldConfigKey.PRODUCT_CONDITION,
        dataKey: 'productcondition',
        labelId: 'ListingPage.condition',
        isArray: false,
      },
      {
        fieldKey: FieldConfigKey.ADULT_KID,
        dataKey: 'adkid',
        labelId: 'ListingPage.targetAudience',
        isArray: true,
      },
    ],
    []
  );

  // Generate specifications data
  const specifications = useMemo(() => {
    return specificationsConfig.map(spec => {
      const value = publicData?.[spec.dataKey];
      const formattedValue = spec.isArray
        ? getLabelsFromOptions(spec.fieldKey, value, listingFields)
        : getLabelsFromOptions(spec.fieldKey, [value], listingFields);

      return {
        labelId: spec.labelId,
        value: formattedValue ?? 'N/A',
      };
    });
  }, [publicData, listingFields, specificationsConfig]);

  const toggleOpen = () => setOpen(prev => !prev);

  return (
    <div className={css.speicifications}>
      <h2 onClick={toggleOpen}>
        <FormattedMessage id="ListingPage.specifications" />
        <Icons name={open ? 'minus' : 'plus'} />
      </h2>
      {open && (
        <section className={css.sectionDetails}>
          <ul className={css.details}>
            {specifications.map((spec, index) => (
              <li key={spec.labelId} className={css.detailsRow}>
                <span className={css.detailLabel}>
                  <FormattedMessage id={spec.labelId} />
                </span>
                <span>{spec.value}</span>
              </li>
            ))}
          </ul>
        </section>
      )}
    </div>
  );
};

export default SpecificationsSection;
